import styles from "./summary.module.css";
import usePhase from "utils/usePhase";
import useEditing, { useEditableInput } from "./useEditing";
import useStore from "utils/useStore";
import constants from "constants/fi.json";

import { useReligions } from "views/_contact";

const Deceased = () => {
  const t = usePhase("summary");
  const deceasedName = useStore((state) => state.deceasedName);
  const deceasedSocialId = useStore((state) => state.deceasedSocialId);
  const deceasedChurch = useStore((state) => state.deceasedChurch);
  const deceasedWishes = useStore((state) => state.deceasedWishes);

  const religions = useReligions();

  const [isEditing, , ConfirmCancel, , , , , Add] = useEditing();
  const [Input, Dropdown, save] = useEditableInput();

  const confirm = () => {
    save();
  };

  return (
    <div className={styles.block}>
      <div className={styles.subtitle}>
        <h3 className="h3">{constants.deceased_info}</h3>
        <Add />
      </div>
      {!isEditing && (
        <div className={styles.content}>
          <p>{constants.deceased_info_desc}</p>
          {deceasedName && (
            <p>
              <span className={styles.key}>{t("name")}</span>
              <span>{deceasedName}</span>
            </p>
          )}
          {deceasedSocialId && (
            <p>
              <span className={styles.key}>{t("social_id")}</span>
              <span>{deceasedSocialId}</span>
            </p>
          )}
          {deceasedChurch && (
            <p>
              <span className={styles.key}>{t("church")}</span>
              <span>{deceasedChurch?.title}</span>
            </p>
          )}
          {deceasedWishes && (
            <p>
              <span className={styles.key}>{t("deceased_wishes")}</span>
              <span>{deceasedWishes}</span>
            </p>
          )}
        </div>
      )}
      {isEditing && (
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={styles.key}>{t("name")}</div>
            <Input valueKey="deceasedName" value={deceasedName} clearOnFocus />
          </div>
          <div className={styles.row}>
            <div className={styles.key}>{t("social_id")}</div>
            <Input valueKey="deceasedSocialId" value={deceasedSocialId} clearOnFocus />
          </div>
          <div className={styles.row}>
            <div className={styles.key}>{t("church")}</div>
            <Dropdown
              valueKey="deceasedChurch"
              options={religions}
              placeholder={t("select_religion")}
              value={deceasedChurch}
              clearable
            />
          </div>
          <div className={styles.row}>
            <div className={styles.key}>{t("deceased_wishes")}</div>
            <Input valueKey="deceasedWishes" value={deceasedWishes} />
          </div>
        </div>
      )}
      <ConfirmCancel confirm={confirm} />
    </div>
  );
};

export default Deceased;
